module.exports = __webpack_public_path__ + "img/28_44.8dcdfd2a.png";